import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import { Button } from '@sitebase/ui-kit/es/buttons';

import { withTranslator } from '@wh/ui-translations';
import { subscribe, publish, unsubscribe } from '../patched-message-bus';
import { onCommandButtonShow, onCommandButtonHide, eventButtonStatus, eventRequested } from './message-bus-helpers';

import './login-button.scss';

var type = '@sitebase/login-button';
var sharedVisible = false;

var onRequestLogin = function onRequestLogin() {
  publish(eventRequested());
};

var LoginButton = function (_Component) {
  _inherits(LoginButton, _Component);

  function LoginButton() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, LoginButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LoginButton.__proto__ || _Object$getPrototypeOf(LoginButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      visible: sharedVisible
    }, _this.setVisible = function (visible) {
      _this.setState({ visible: visible }, function () {
        sharedVisible = visible;
        publish(eventButtonStatus({ visible: visible }));
      });
    }, _this.showButton = function () {
      return _this.setVisible(true);
    }, _this.hideButton = function () {
      return _this.setVisible(false);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(LoginButton, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.subscribeIds = [subscribe(onCommandButtonShow(this.showButton)), subscribe(onCommandButtonHide(this.hideButton))];
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.subscribeIds && this.subscribeIds.length) {
        this.subscribeIds.forEach(function (subscribeId) {
          return unsubscribe(subscribeId);
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          t = _props.t,
          data = _props.data;
      var visible = this.state.visible;


      return visible ? React.createElement(
        Button,
        {
          className: 'action-login__button',
          onClick: onRequestLogin,
          outfit: 'yellow hollow small',
          key: 'pih.' + type,
          'data-test-id': '' + type + (data.id ? '_' + data.id : '')
        },
        t('header')('login-button')
      ) : null;
    }
  }]);

  return LoginButton;
}(Component);

var LoginButtonWithTranslator = withTranslator(LoginButton);

export default {
  type: type,
  render: function render(_ref2) {
    var data = _ref2.data;
    return React.createElement(LoginButtonWithTranslator, { key: 'pih.login-button', data: data });
  }
};
//# sourceMappingURL=login-button.js.map